document.addEventListener("DOMContentLoaded", () => {
	const nav = document.querySelector(".js-sticky-nav");
	if (!nav) return;

	const anchorsNav = nav.querySelector(".anchors-nav");
	const links = nav.querySelectorAll(".anchors-nav a");
	const sections = Array.from(links)
		.map((link) => document.querySelector(link.getAttribute("href")))
		.filter(Boolean);

	const sentinel = document.querySelector(".sticky-sentinel");
	const topOffset = parseInt(getComputedStyle(nav).top, 10) || 0;
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const stickyBuffer = 6;
	let stickyTicking = false;

	const scrollActiveLinkIntoView = (activeLink) => {
		if (!anchorsNav || !activeLink) return;
		if (anchorsNav.scrollWidth <= anchorsNav.clientWidth) return;

		const targetLeft = Math.max(0, activeLink.offsetLeft - (anchorsNav.clientWidth - activeLink.offsetWidth) / 2);

		anchorsNav.scrollTo({
			left: targetLeft,
			behavior: prefersReducedMotion ? "auto" : "smooth",
		});
	};

	const setActiveLink = (activeLink) => {
		if (!activeLink) return;

		links.forEach((link) => link.classList.remove("is-active"));
		activeLink.classList.add("is-active");
		scrollActiveLinkIntoView(activeLink);
	};

	const updateStickyState = () => {
		if (!sentinel) return;

		const sentinelTop = sentinel.getBoundingClientRect().top;
		const shouldStick = nav.classList.contains("is-sticky") ? sentinelTop <= topOffset + stickyBuffer : sentinelTop < topOffset - stickyBuffer;

		nav.classList.toggle("is-sticky", shouldStick);
		stickyTicking = false;
	};

	const requestStickyUpdate = () => {
		if (stickyTicking) return;
		stickyTicking = true;
		requestAnimationFrame(updateStickyState);
	};

	if (sentinel) {
		window.addEventListener("scroll", requestStickyUpdate, { passive: true });
		window.addEventListener("resize", requestStickyUpdate);
		requestStickyUpdate();
	}

	const spyObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const activeLink = nav.querySelector(`a[href="#${entry.target.id}"]`);
					setActiveLink(activeLink);
				}
			});
		},
		{
			rootMargin: `-50% 0px -50% 0px`, // déclenche quand la section est au centre
			threshold: 0,
		},
	);

	sections.forEach((section) => spyObserver.observe(section));

	setActiveLink(nav.querySelector(".anchors-nav a.is-active") || links[0]);



	const formationAnchors = document.querySelectorAll("[data-trigger='formation-anchor']");
	if (formationAnchors.length > 0) {
		formationAnchors.forEach((anchor) => {
			anchor.addEventListener("click", (e) => {
				e.preventDefault();
				// Find the destination section inside .wpb-content-wrapper containing .gform_wrapper
				const wpbContentWrapper = document.querySelector('.wpb-content-wrapper');
				if (wpbContentWrapper) {
					const gformContainer = wpbContentWrapper.querySelector('section:has(.gform_wrapper)');
					if (gformContainer) {
						const formationNav = document.querySelector('.formation__nav');
						const formationNavHeight = formationNav ? formationNav.offsetHeight : 0;

						const rect = gformContainer.getBoundingClientRect();
						const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
						const topPosition = rect.top + scrollTop - formationNavHeight;

						window.scrollTo({
							top: topPosition,
							behavior: "smooth"
						});
					}
				}
			});
		});
	}


});
